export default __webpack_public_path__ + "static/nyt-465f3a074f50cb8762debe27aaaa4ba1.png";